import { render, staticRenderFns } from "./candidate-info-card.vue?vue&type=template&id=5d80492d"
import script from "./candidate-info-card.vue?vue&type=script&lang=js"
export * from "./candidate-info-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports